import { FC, ReactNode } from 'react';

import * as S from './ShipActionButton.styles';

export type ShipActionVariant = 'deposit' | 'withdraw';

interface ShipActionButtonProps {
  variant: ShipActionVariant;
  onClick?: () => void;
  children: ReactNode;
}

export const ShipActionButton: FC<ShipActionButtonProps> = ({ variant, onClick, children }) => {
  return (
    <S.ActionButton $variant={variant} onClick={onClick}>
      {children}
    </S.ActionButton>
  );
};
